export const BREAKPOINTS = {
  xl: '(max-width: 1919px)',
  lg: '(max-width: 1279px)',
  md: '(max-width: 767px)',
  sm: '(max-width: 427px)',
};

// TODO remove what's below 
export const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobilePlus: '400px',
  mobileL: '428px',
  mobileXL: '515px',
  tabletS: '700px',
  newTabletS: '706px',
  tablet: '768px',
  tabletM: '940px',
  laptop: '1024px',
  laptopM: '1279px',
  laptopL: '1280px',
  laptopXL: '1430px',
  desktop: '1920px',
};

export const deviceMax = {
  mobileS: `(max-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobilePlus: `(max-width: ${size.mobilePlus})`,
  mobileL: `(max-width: ${size.mobileL})`,
  mobileXL: `(max-width: ${size.mobileXL})`,
  tabletS: `(max-width: ${size.tabletS})`,
  tablet: `(max-width: ${size.tablet})`,
  newTabletS: `(max-width: ${size.newTabletS})`,
  tabletM: `(max-width: ${size.tabletM})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopLMax: `(max-width: ${size.laptopL})`,
  laptopL: `(max-width: ${size.laptopL})`,
  laptopM: `(max-width: ${size.laptopM})`,
  laptopXL: `(max-width: ${size.laptopXL})`,
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktop})`,
};

export const deviceMin = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  mobileXL: `(min-width: ${size.mobileXL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  laptopM: `(min-width: ${size.laptopM})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktop})`,
};

export const isMobileL = window.matchMedia(deviceMax.mobileL).matches;
export const isTablet = window.matchMedia(deviceMax.tablet).matches;
export const isLaptopM = window.matchMedia(deviceMax.laptopM).matches;
